import { TouchableOpacity, View } from "react-native";
import { Checkbox, Text } from "react-native-paper";
import { Control, Controller } from "react-hook-form";
import { Chip as ChipStyled } from "../../components/styled";
import { EventDetailsQuery, FormData } from "./types";
import { readableDate, convertToTimezone } from "../../utils/dateUtils";

const AvailableSession = ({
  id,
  control,
  title,
  startsAt,
  timezone,
}: {
  id: string;
  control: Control<FormData>;
  title: string;
  startsAt: string;
  timezone: string;
}) => (
  <Controller
    name={`sessions.${id}`}
    control={control}
    render={({ field: { value, onChange } }) => (
      <TouchableOpacity
        testID={`session-${id}`}
        activeOpacity={0.7}
        onPress={() => {
          onChange(!value);
        }}
        className={`flex flex-row rounded-lg mb-3 ${
          value ? "border-primary-lighter border-2 p-3" : "border-sky-dark border p-[13px]"
        }`}
      >
        <View className="self-center mr-2">
          <Checkbox.Android status={value ? "checked" : "unchecked"} />
        </View>
        <View className="flex-1">
          <View className="flex-row">
            <Text className="w-3/4 font-700 text-regular-tight mb-1">{title}</Text>
          </View>
          <Text>{readableDate(convertToTimezone(startsAt, timezone))}</Text>
        </View>
      </TouchableOpacity>
    )}
  />
);

const UnavailableSession = ({
  id,
  title,
  startsAt,
  timezone,
}: {
  id: string;
  title: string;
  startsAt: string;
  timezone: string;
}) => (
  <View testID={`session-${id}`} className="flex flex-row rounded-lg mb-3 border-sky-light border p-[13px]">
    <View className="self-center mr-2">
      <Checkbox.Android disabled status="unchecked" />
    </View>
    <View className="flex-1">
      <View className="flex-row">
        <Text className="w-3/4 font-700 text-regular-tight mb-1 text-sky-dark">{title}</Text>
        <ChipStyled className="float-right rounded-2xl bg-yellow-lightest" textStyle="my-0.5" testID="registration-full">
          <Text className="text-yellow-dark font-500">Registration Full</Text>
        </ChipStyled>
      </View>
      <Text className="text-sky-dark">{readableDate(convertToTimezone(startsAt, timezone))}</Text>
    </View>
  </View>
);

export default function SessionOptions({ event, control }: { event: EventDetailsQuery["event"]; control: Control<FormData> }) {
  return (
    <View testID="session-options">
      <View className="bg-sky-light h-[1px] my-8" />
      <Text className="text-large-normal font-700">Planned Attendance</Text>
      <Text className="text-regular-normal mt-2">Select the day(s) you plan to attend.</Text>
      <View className="mt-6">
        {event.sessions.map(
          ({
            id,
            startsAt,
            title,
            hasAvailability,
          }: {
            id: string;
            startsAt: string;
            title: string;
            hasAvailability: boolean;
          }) => (
            <View key={id}>
              {hasAvailability ? (
                <AvailableSession id={id} startsAt={startsAt} title={title} timezone={event.timezone} control={control} />
              ) : (
                <UnavailableSession id={id} startsAt={startsAt} timezone={event.timezone} title={title} />
              )}
            </View>
          )
        )}
      </View>
    </View>
  );
}
